import api from '@/api/fetch'
import type { Promotion } from '@/types'

export function getPromotions() {
  return api.get<Promotion[]>('/promotions').then(res => res.data)
}
